import React from "react";
import PriceField from "../PriceField";
import { ImgIcon } from "../../../assets";
import { visible, hidden, remove, reset, cross } from "../../../assets/icons";
import { updateShopProduct, deleteShopProduct, createVariant } from "../../../actions/shop";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";

export default function VariantManager({ variants, product }) {

	const [newVariant, setEditing] = useState(false);

	return <div className="variantManager">
		{/* List of existing variants */}
		<div className="variants-list">
			{variants.map(variant => (
				<VariantEditor
					key={variant.id}
					parent={product}
					variant={variant}
				/>
			))}
		</div>

		{/* Creating a new variant */}
		{!newVariant
			? (
				<div className="create-variant padded bordered v-middle">
					<span className="featureFont">
						Add a variant
					</span>
					<button className="normalFont" onClick={e => setEditing(true)}>+</button>
				</div>
			) : (
				<div className="variant-creator">
					<div className="padded">
						<h4>Creating a variant</h4>
					</div>
					<VariantEditor
						parent={product}
						variant={{ price: product.price }}
						onExit={() => setEditing(false)}
					/>
				</div>
			)}
	</div>
}

function VariantEditor({ variant, onExit, parent }) {

	const [changes, setChanges] = useState({});
	const dispatch = useDispatch();

	useEffect(() => {
		setChanges({});
	}, [variant]);

	const values = {
		...(variant || {}),
		...changes
	}

	const iconSettings = {
		size: 30,
		iconSize: "65%"
	}

	const canSubmit = (
		values.price &&
		values.name
	);

	return <div className="variant padded bordered" >
		<div className="flexy" style={{ marginBottom: 10 }}>
			<input
				style={{
					flex: 2,
					marginRight: 10
				}}
				type="text"
				name="name"
				placeholder="Name"
				value={values.name || ""}
				onChange={e => setChanges({ ...changes, name: e.target.value })}
			/>
			<PriceField
				style={{
					flex: 1,
					marginleft: 10
				}}
				placeholder="Price"
				value={values.price || 0}
				onChange={price => setChanges({ ...changes, price })}
			/>
		</div>
		<textarea
			value={values.description || ""}
			placeholder="Description"
			onChange={e => setChanges({ ...changes, description: e.target.value })}
		/>

		{Boolean(!values.id && canSubmit) && <button
			onClick={e => dispatch(createVariant(parent.id, values, () => {
				if (onExit) onExit();
			}))}
			style={{ width: "100%", marginTop: 10 }}
		>Create</button>}

		{Boolean(values.id && canSubmit && Object.keys(changes).length) && <button
			onClick={e => dispatch(updateShopProduct(values.id, changes))}
			style={{ width: "100%", marginTop: 10 }}
		>Save</button>}

		<div className="controls">
			{Boolean(values.id && !Object.keys(changes).length) && <ImgIcon
				className="brand-bg"
				title={values.available ? "This variant is available. Click to hide." : "This variant is hidden. Click to make available."}
				src={values.available ? visible : hidden}
				{...iconSettings}
				style={!values.available ? {
					backgroundColor: "#f7f7f7"
				} : {}}
				onClick={e => {
					e.stopPropagation();
					dispatch(updateShopProduct(values.id, { available: !values.available }));
				}}
			/>}
			{Boolean(values.id) && <ImgIcon
				title="Delete variant."
				src={remove}
				{...iconSettings}
				bg={"#f7f7f7"}
				onClick={e => {
					e.stopPropagation();
					if (!window.confirm("Are you sure you want to remove the variant? This cannot be undone. If you just want to hide it, press the eye icon.")) return;
					dispatch(deleteShopProduct(values.id));
				}}
			/>}
			{Boolean(values.id && Object.keys(changes).length) && <ImgIcon
				title="Clear"
				src={reset}
				bg={"#f7f7f7"}
				{...iconSettings}
				onClick={e => setChanges({})}
			/>}
			{Boolean(onExit) && <ImgIcon
				title="Cancel"
				src={cross}
				bg={"#f7f7f7"}
				{...iconSettings}
				onClick={e => onExit()}
			/>}
		</div>
	</div>
}